import { render } from "./ParamPriceCostPageList.vue?vue&type=template&id=4509e263&scoped=true&ts=true"
import script from "./ParamPriceCostPageList.vue?vue&type=script&lang=ts"
export * from "./ParamPriceCostPageList.vue?vue&type=script&lang=ts"

import "./ParamPriceCostPageList.vue?vue&type=style&index=0&id=4509e263&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4509e263"]])

export default __exports__